// import CHIPSAJ from "./_chips-aj.js";
// import CHIPSMENU from "./components/_menu.js";
import CHIPSSLIDER from "./components/_chips-slider.js";
//import ImageCloud from "./components/_image-cloud.js";
import { createApp, reactive } from "petite-vue";

// import slickSlideshow from "./components/slickSlideshow.js";
import swiperSlideshow from "./components/swiperSlideshow.js";
import imageCloud from "./components/imageCloud.js";
import historyTimeline from "./components/historyTimeline.js";
import statsSlideshow from "./components/statsSlideshow.js";
import ajaxViewControl from "./components/ajaxViewControl.js";
import ajaxLoadMoreButton from "./components/ajaxLoadMoreButton.js";
import scrollGallery from "./components/scrollGallery.js";
import typologySubnav from "./components/typologySubnav.js";

// import { createApp, reactive } from "https://unpkg.com/petite-vue?module";
// import FILTERPEOPLE from "./components/_filters-people.js";

class App {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		this.init();
	}

	init() {
		/* DO something on load */
		this.sliders = new CHIPSSLIDER();
		// this.initMenu = new CHIPSMENU();
		// this.imgCloud = new ImageCloud();
		// ImageCloud.init();
		// this.filtersPeople = new FILTERPEOPLE();

		this.initSwiperSliders();
		this.initImageCloud();
		this.initHistoryTimeline();
		this.initStatsSlideshow();
		this.initAjaxViewControl();
		this.initAjaxLoadMoreButton();
		this.initScrollGal();
		this.initGenericUX();
		this.initTypologySubnav();
	}

	initSwiperSliders() {
		let $swiper = $(".swiper");
		if ($swiper.length > 0) {
			$swiper.each((i, el) => {
				new swiperSlideshow({
					$el: $(el),
				});
			});
		}

		let $swiperMo = $(".mo-carousel");
		if ($swiperMo.length > 0) {
			$swiperMo.each((i, elMo) => {
				new swiperSlideshow({
					$el: $(elMo),
				});
			});
		}
	}

	initImageCloud() {
		let $cloud = $("section.image-cloud");
		if ($cloud.length > 0) {
			new imageCloud({
				$el: $cloud,
			});
		}
	}

	initHistoryTimeline() {
		let $timeline = $(".timeline .desktop-view");
		if ($timeline.length > 0) {
			new historyTimeline({
				$el: $timeline,
			});
		}
	}

	initStatsSlideshow() {
		let $s = $(".stats-slideshow");
		if ($s.length > 0) {
			$s.each((i, el) => {
				new statsSlideshow({
					$el: $(el),
				});
			});
		}
	}

	initAjaxViewControl() {
		let $s = $(".ajax-view-control");
		if ($s.length > 0) {
			$s.each((i, el) => {
				new ajaxViewControl({
					$el: $(el),
					//trace_debug: true
				});
			});
		}
	}

	initAjaxLoadMoreButton() {
		let $s = $(".ajax-load-more-button");
		if ($s.length > 0) {
			$s.each((i, el) => {
				new ajaxLoadMoreButton({
					$el: $(el),
					//trace_debug: true
				});
			});
		}
	}

	initScrollGal() {
		new scrollGallery();
	}

	initTypologySubnav() {
		new typologySubnav();
	}

	initGenericUX() {
		$(".jpg-cover").on("click", function () {
			var iframe = $(this).parent().find("iframe");
			iframe.attr("src", iframe.attr("data-src"));
			$(this).addClass("interacted");
		});

		$("a").each(function () {
			var a = new RegExp("/" + window.location.host + "/");
			if (!a.test(this.href)) {
				$(this).click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					window.open(this.href, "_blank");
				});
			}
		});

		// section-scroll_gallery
	}
}

const app = new App();

/*
$(document).ready( ()=>{

	const app = new App();

});
*/

/* TEMP STUFF */
// Grid on/off
$(document).on("keyup", function (e) {
	if (e.keyCode === 192) {
		$(".grid-overlay").toggleClass("hidden");
	}
});

function getRandImg() {
	let imgSet = [
		"https://dialogca.wpengine.com/wp-content/uploads/2022/01/sample-tree-background__ScaleMaxWidthWzIwMDBd-1.png",
		"https://dialogca.wpengine.com/wp-content/uploads/2022/01/sample-tree-background__ScaleMaxWidthWzIwMDBd.png",
		"https://dialogca.wpengine.com/wp-content/uploads/2022/01/sample-awards__FocusFillWzEzNTIsNzIxLCJ4IiwyODRd_ScaleMaxWidthWzMwMDBd.png",
		"https://dialogca.wpengine.com/wp-content/uploads/2022/01/temp-placeholder-scaled.jpg",
	];
	let randImg = Math.floor(Math.random() * imgSet.length);
	return imgSet[randImg];
}
function getRandImgPeople() {
	let imgSet = [
		"https://dialogca.wpengine.com/_sg-assets/keith-robinson-2019-website-bio__FocusFillWzE3MDYsMjEzMywieCIsMzEzXQ_ScaleMaxWidthWzYwMF0.jpg",
		"https://dialogca.wpengine.com/_sg-assets/michael-corpuz-2019-website-bio__FocusFillWzE3MDYsMjEzMywieCIsOTEwXQ_ScaleMaxWidthWzYwMF0.jpg",
		"https://dialogca.wpengine.com/_sg-assets/doug-carlyle-2019-website-bio__FocusFillWzE3MDYsMjEzMywieCIsNzk2XQ_ScaleMaxWidthWzYwMF0.jpg",
		"https://dialogca.wpengine.com/_sg-assets/donna-clare-website-bio__FocusFillWzE3MDYsMjEzMywieCIsODI1XQ_ScaleMaxWidthWzYwMF0.jpg",
		"https://dialogca.wpengine.com/_sg-assets/jim-montgomery-2019-website-bio__FocusFillWzE3MDYsMjEzMywieCIsOTI0XQ_ScaleMaxWidthWzYwMF0.jpg",
	];
	let randImg = Math.floor(Math.random() * imgSet.length);
	return imgSet[randImg];
}
$(".img-placeholder, .faux-img").each(function () {
	var newSrc = getRandImg();
	if ($(this).hasClass("person")) {
		newSrc = getRandImgPeople();
	}
	$(this).html('<img src="' + newSrc + '" border="0">');
});

function colorCycle() {
	let availColors = [
		"hl-red",
		"hl-orange",
		"hl-gray",
		"hl-darkblue",
		"hl-green",
		"hl-magenta",
		"hl-cyan",
	];
	let colorRandom = Math.floor(Math.random() * availColors.length);
	return availColors[colorRandom];
}

$(".color-cycle").each(function () {
	let scopeThis = $(this);
	setInterval(function () {
		scopeThis.attr("data-highlight", colorCycle());
	}, 5000);
});

$(".filter-button,.filter-button-close").on("click", function (e) {
	e.preventDefault();
	// $(this).closest(".filters").toggleClass("filters-on");
});

if (typeof gridData !== "undefined" && gridData) {
	const filters = {
		all(todos) {
			return todos;
		},
		principal(todos) {
			return todos.filter((todo) => {
				return todo.Principal;
			});
		},
		// completed(todos) {
		// 	return todos.filter(function (todo) {
		// 		return todo.completed;
		// 	});
		// },
	};

	let cardGrid = createApp({
		// todos: todoStorage.fetch(),
		gridItems: gridData,
		quoteItems: null,
		newTodo: "",
		editedTodo: null,
		visibility: "all",
		dataShown: "all",
		groupShown: "associates",
		filter_loc: "All",
		filter_disc: "All",
		filtersOn: false,

		get filteredPeople() {
			let subData = this.gridItems;
			if (this.groupShown) {
				subData = subData.filter((gI) => {
					return gI.p == this.groupShown;
				});
			}
			// } else {
			// 	subData = subData.filter((gI) => {
			// 		return gI.p === "True";
			// 	});
			// }
			if (this.filter_loc && this.filter_loc !== "All") {
				subData = subData.filter((gI) => {
					// return this.filter_loc.includes(gI.l);
					return (
						gI.l &&
						gI.l.length > 0 &&
						gI.l.includes(+this.filter_loc || this.filter_loc)
					);
				});
			}
			if (this.filter_disc && this.filter_disc !== "All") {
				subData = subData.filter((gI) => {
					return (
						gI.d &&
						gI.d.length > 0 &&
						gI.d.includes(+this.filter_disc || this.filter_disc)
					);
				});
			}
			return subData;
			// return this.gridItems;
		},

		get principals() {
			// return this.todos.length;
			return filters.principal(this.gridItems).length;
		},

		get allDone() {
			return this.principals === 0;
		},

		set allDone(value) {
			// this.todos.forEach(function (todo) {
			// 	todo.completed = value;
			// });
		},

		save() {
			todoStorage.save(this.gridItems);
		},

		removeTodo(todo) {
			this.gridItems.splice(this.gridItems.indexOf(todo), 1);
		},

		editTodo(todo) {
			this.beforeEditCache = todo.title;
			this.editedTodo = todo;
		},

		pluralize(n) {
			return n === 1 ? "item" : "items";
		},

		mountCB() {
			if (typeof gridQuotes !== "undefined" && gridQuotes) {
				let quotesTmp = gridQuotes.sort(function () {
					return 0.5 - Math.random();
				});
				this.quoteItems = gridQuotes;
			}
		},
	}).mount("#filter_people");
} else {
	// Static for style guide
	$(".filter-button").on("click", function (e) {
		// e.preventDefault();
		$(this).closest(".filters").toggleClass("filters-on");
	});
	$(".filter-button-close").on("click", function (e) {
		// e.preventDefault();
		$(this).closest(".filters").removeClass("filters-on");
	});
}

$(".autoplay-pause").on("click", function () {
	var targetVid = $(this).parent().parent().find("video");
	if (targetVid && targetVid.length > 0) {
		if ($(this).hasClass("isPlaying")) {
			$(this).removeClass("isPlaying").addClass("isPaused");
			targetVid[0].pause();
		} else {
			$(this).removeClass("isPaused").addClass("isPlaying");
			targetVid[0].play();
		}
	}
});
